import React from "react";
import PreviewImg from "../atoms/PreviewImg";
import PreviewTitle from "../atoms/PreviewTitle";
import {useSelector} from "react-redux";
import usePartOptionController from "../organisms/usePartOptionController";
import {useShootingPoint} from "../../../../hooks/controller/useShootingPoint";

const PartOptionMain = ({
                          partArray,
                          code,
                          title,
                          stepObject,
                          navigationDataObject,
                          personalItemObject,
                          slideToSubHandler
                        }) => {
  const sendData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const {shootingPointChangeHandler} = useShootingPoint(code, navigationDataObject.linkPath);

  const {findSelectedPartItem} = usePartOptionController(partArray, stepObject);

  const codeKeyData = sendData[code];
  const findSelectedData = findSelectedPartItem(stepObject, codeKeyData, personalItemObject);
  const {partSwitch, selectedItem} = findSelectedData;

  return (
    <div className={"option-h3"} data-value={!!sendData[code]}>
      <div className={"option-value part-option-value"} onClick={(e) => {
        shootingPointChangeHandler(e, stepObject, partSwitch);
        slideToSubHandler({
          id: navigationDataObject.id,
          stepId: stepObject.id,
          targetDepth: "3"
        });
      }}>
        <PreviewImg selectedItem={selectedItem} type={"PART"}/>
        <PreviewTitle selectedItem={selectedItem} title={title} type={"PART"}/>
      </div>
    </div>
  );
}

export default PartOptionMain;
